export default "__VITE_ASSET__03732f76__"